// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product', {
        url: '/product',
        parent: 'main',
        abstract: true,
        templateUrl: 'main/product/product.tpl.html',
        controller: 'MainProductsController as vm'
    });
}

// @ngInject
function MainProductsController() {
    var vm = this;
}

angular.module('main.product', [
    'products.api',
    'rms2Products.api',
    'product.service',
    'variants.api',
    'variantgroups.api',
    'product.articles',
    'product.pricelistmgmt',
    'product.importfileslist',
    'product.maingroups',
    'product.brands',
    'product.saleschannels',
    'product.intrastats',
    'product.productimport',
    'product.subcategories',
    'product.pricelists',
    'product.psychologicalprices',
    'product.departments',
    'product.variants',
    'product.variantgroups',
    'product.priceListEditor',
    'product.volumediscounts',
    'product.businessareas',
    'product.productimporteditor'
    ])
    .config(stateConfig)
    .controller('MainProductsController', MainProductsController);
